// Recovery for a request the proof-of-work gate refused: the 403 carries the
// invisible altcha widget, which solves a fresh challenge and sets the cookie
// the retry needs.
;(() => {
  let pending = null

  // Scripts parsed through innerHTML never run ("when inserted using the
  // innerHTML and outerHTML attributes, they do not execute at all" —
  // https://html.spec.whatwg.org/multipage/scripting.html#the-script-element),
  // so the widget's loader tags are re-created the way Turbo does for the
  // script tags in its stream templates.
  function activateScripts(fragment) {
    const nonce = document.querySelector("meta[name=csp-nonce]")?.content

    for (const script of fragment.querySelectorAll("script")) {
      const activated = document.createElement("script")

      for (const { name, value } of script.attributes) {
        activated.setAttribute(name, value)
      }
      if (nonce) activated.nonce = nonce
      activated.textContent = script.textContent

      script.replaceWith(activated)
    }
  }

  function mount(widgetHtml) {
    const template = document.createElement("template")
    template.innerHTML = widgetHtml
    activateScripts(template.content)

    const widget = template.content.querySelector("altcha-widget")
    document.body.appendChild(template.content)

    return widget
  }

  // Settles verified or not: a caller retries either way and gives up on a
  // second refusal, so a failed widget must not leave it hanging. Callers
  // refused together share the one widget.
  function solve(widgetHtml) {
    pending ||= new Promise((resolve) => {
      const widget = mount(widgetHtml)

      widget.addEventListener("statechange", ({ detail }) => {
        if (detail.state !== "verified" && detail.state !== "error") return

        widget.remove()
        pending = null
        resolve()
      })
    })

    return pending
  }

  window.HB = window.HB || {}
  window.HB.proofOfWork = { solve }
})()
